<template>
  <div>
    <VPageElements
      :breakpoint="breakpoint"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import VPageElements from '@c/PageElements'

export default {
  components: {
    VPageElements
  },

  data () {
    return {
      breakpoint: 0
    }
  },

  created () {
    this.refreshBreakpoint()
    window.addEventListener('resize', _.throttle(this.refreshBreakpoint))
  },

  beforeDestroy () {
    window.removeEventListener('resize', _.throttle(this.refreshBreakpoint))
  },

  computed: {
    isMobile () {
      return this.breakpoint < 672
    }
  },

  methods: {
    refreshBreakpoint () {
      this.breakpoint = parseInt(window
        .getComputedStyle(document.querySelector('body'), ':before')
        .getPropertyValue('content')
        .replace(/"/g, ''))
    }
  }
}
</script>
